const Constants = {
  referenceLineColor: '#FFA700',
  strokeWidth: 2,
  handleSizeRadius: 5,
  defaultReferencePoints: [{ x: 100, y: 100 }, { x: 200, y: 100 }],
  defaultReferenceValue: 100,
  gridPixelSize: 20,
  minZoom: 0.1,
  maxZoom: 10,
  fitMinMargin: 80, // screen px
  fitMarginRatio: 0.2, // of the smaller canvas side
  fitMaxZoomOverBackground: 3, // a small area still shows a third of the plan around it
  subGridRatio: 2,
  gridLineStyle: {
    stroke: '#ccc',
    selectable: false,
    evented: false,
    type: 'grid',
    opacity: 1
  }
}

export default Constants
